import { render, staticRenderFns } from "./OrderDocumentUploadModalPublic.vue?vue&type=template&id=3dcb6221"
import script from "./OrderDocumentUploadModalPublic.vue?vue&type=script&lang=js"
export * from "./OrderDocumentUploadModalPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports